import React from 'react';
import { Register } from '../factory';
import MultipleSelecter from '../../common/selecter/multiple';
import ListFromItemRt from '../form-item-rt';
import { DYFormItem } from '../../../types';

type DyCheckboxProps = DYFormItem & Props;

@Register({ name: 'dy-checkbox' })
class DyCheckbox extends React.Component<DyCheckboxProps, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }
    localValue: any = null;
    handleChange = value => {
        this.localValue = value;
        this.props.onChange && this.props.onChange(value);
    };

    render() {
        const { className, label, value, desc, options } = this.props;
        let content = value && value.map(item => <div key={item.content}>{item.content}</div>);
        return (
            <MultipleSelecter className={className} title={label} value={value} options={options} {...desc} onChange={this.handleChange}>
                <ListFromItemRt content={content} arrow={true} />
            </MultipleSelecter>
        );
    }
}

export default DyCheckbox;
